

// import Swiper from "./swiper";

import Splide from '@splidejs/splide';
// Esporta Splide per renderlo disponibile agli altri moduli
export { Splide };



// import { sliderGalleryV1 } from "./gallery/v1/slider";
// import { sliderGalleryV2 } from "./gallery/v2/slider";

// import { sliderLineeV1 } from "./linee/v1/slider";
// import { sliderLineeV2 } from "./linee/v2/slider";

// import { sliderFrasiV1 } from "./frasi/v1/slider";

// import { sliderPtV1 } from "./pt/v1/slider";
// import { sliderPtV2 } from "./pt/v2/slider";

// import { sliderHeroV1 } from "./hero/v1/slider";


// new Swiper([
//   // sliderGalleryV1,
//   // sliderGalleryV2,
//   // sliderLineeV1,
//   // sliderLineeV2,
//   // sliderFrasiV1,
//   // sliderPtV1,
//   // sliderPtV2,
//   // sliderHeroV1,
// ]);



import "./gallery/v1/slider";

import "./hero/v1/slider";
// import "./video/v1/slider";
